import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "./index";

export const Route = createFileRoute("/en/")({
  head: () => {
    const y = new Date().getFullYear();
    const ld = [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "Indonesian Calendar",
        url: "https://hari.co.id/en",
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Indonesian Calendar",
        url: "https://hari.co.id/en",
      },
    ];
    return {
      meta: [
        { title: `Indonesia Calendar ${y}: Today's Date, Tomorrow & Public Holidays` },
        { name: "description", content: `Indonesia calendar ${y}: what day is today, tomorrow's date, public holidays, joint leave, Hijri, Javanese (weton), and Balinese. Free PDF download.` },
        { name: "keywords", content: `what day is today, tomorrow's date, indonesia calendar ${y}, public holidays ${y}, joint leave ${y}, hijri calendar, javanese calendar, weton today` },
        { property: "og:title", content: `Indonesia Calendar ${y} - Today & Tomorrow` },
        { property: "og:description", content: `Check today, tomorrow's date, public holidays & joint leave for ${y}.` },
      ],
      links: [{ rel: "canonical", href: "https://hari.co.id/en/" }],
      scripts: ld.map((obj) => ({
        type: "application/ld+json",
        children: JSON.stringify(obj),
      })),
    };
  },
  component: () => <HomePage locale="en" />,
});